/**
 * Имена аватарок игрока: данные без React, общие для сцены и разметки (`pawn.ts`, `pawn.markup.tsx`).
 */

/** Лист аватарок: двенадцать символов `avatar-0-<имя>`. */
export const AVATAR_SHEET = 'board-avatars-0.svg'

/*
 * Порядок ячеек листа — порядок в Figma, слева направо и сверху вниз: первая
 * строка мальчики, вторая девочки. Имена описывают то, что нарисовано, и
 * дальше клетки листа не уходят: в партии аватарка выдаётся по месту за
 * столом, а не по имени, и в протоколе её нет.
 */
export const PLAYER_AVATARS = [
  'boy-1',
  'boy-2',
  'boy-3',
  'boy-4',
  'boy-5',
  'boy-6',
  'girl-1',
  'girl-2',
  'girl-3',
  'girl-4',
  'girl-5',
  'girl-6',
] as const

/**
 * Аватарка игрока: его выбор, а если выбора не было или набор сменился — по
 * месту за столом. Раньше это выражение лежало в трёх местах.
 */
export function avatarFor(choice: string, seat: number): (typeof PLAYER_AVATARS)[number] {
  return (PLAYER_AVATARS as readonly string[]).includes(choice)
    ? (choice as (typeof PLAYER_AVATARS)[number])
    : PLAYER_AVATARS[seat % PLAYER_AVATARS.length]
}
